import * as React from 'react';
import styled from 'styled-components';
import { fontSize, borderColor } from 'styled-system';
import { themeGet, Box, BoxProps } from '@packages/ui';

import { ModuleHeadline, HeadlineStyle, HeadlineTag } from '@packages/common';

export const Container = styled(Box)<BoxProps>`
  color: ${themeGet.colors('judgeGray')};
  border-color: #dfdcd9;
  ${borderColor}

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    text-align: center;
    font-family: ${themeGet.fonts('brandSecondary')};
    font-weight: ${themeGet.fontWeight('normal')};
    font-size: inherit;
    color: inherit;
    border-color: inherit;
    display: block;
    padding: 0;
    margin: 0;

    &::before {
      /* 
      insert non-breaking-space to end-up with the same height than the headline itself 
      to be able to use translate accordingly 
      */
      content: '\\00a0';
      display: block;
      margin-top: -2px;
      transform: translateY(50%);
      border-top-width: 2px;
      border-top-style: dotted;
      border-color: inherit;
      position: absolute;
      left: 0;
      right: 0;
    }

    > span {
      display: inline-block;
      position: relative;
      background-color: ${themeGet.colors('white')};
      padding-left: 10px;
      padding-right: 10px;
    }
  }
`;

const StyledH2 = styled.h2`
  ${fontSize}
`;

const paddingTop = [3, 3, 3, 3, 4];
const paddingBottom = 0;
const fontSizeMap: { [key in HeadlineStyle]: number[] } = {
  [HeadlineStyle.H1]: [10, 10, 12, 15],
  [HeadlineStyle.H2]: [8, 8, 8, 12],
  [HeadlineStyle.H3]: [7, 7, 7, 8],
};

export type HeadlineProps = ModuleHeadline &
  Pick<BoxProps, 'pt' | 'pb'> & {
    className?: string;
  };

export const Headline: React.FC<HeadlineProps> = ({
  children,
  text,
  className,
  color,
  style = HeadlineStyle.H2,
  pt = paddingTop,
  pb = paddingBottom,
  as = HeadlineTag.H2,
}) => {
  return (
    <>
      {(text || children) && (
        <Container
          pt={pt}
          pb={pb}
          color={color}
          className={className}
          fontSize={fontSizeMap[style]}
          data-testid="cms-headline"
        >
          <StyledH2 as={as as any}>
            <span>{text || children}</span>
          </StyledH2>
        </Container>
      )}
    </>
  );
};

export const HeadlineWithPaddingBottom = Headline;
